export default __webpack_public_path__ + "static/media/cooking.69922e5e.jpeg";